/* eslint-disable max-classes-per-file */
import Cookies from 'js-cookie';
import { UserUtils } from '../utils/user';
import { easyPost } from './utils';

function getKey(key) {
  return `${key}_h5_${((window.env && window.env.VUE_APP_ENV) || process.env.NODE_ENV)}`;
}

/**
 * path匹配到环境为止的正则
 * 例如: /ebike-h5/{env}
 */
const cookiePathReg = /\/[^/]+\/([^/]+\/)?/;
const pathMatch = (pathname) => {
  const matches = pathname.match(cookiePathReg);
  if (matches) {
    return matches[0];
  }
  return pathname;
};

const tld = (hostname) => {
  // 本地调试通过localhost或IP访问
  if (hostname === 'localhost'
    || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return hostname;
  }
  return hostname.split('.').slice(1).join('.');
};

const getCurrentPath = () => pathMatch(window.location.pathname);

const getTopLevelDomain = () => tld(window.location.hostname);

class Cookie {
  static setItem(key, val, expirationDate) {
    if (val !== undefined) {
      // eslint-disable-next-line no-undef
      return Cookies.set(getKey(key), val, {
        path: getCurrentPath(),
        domain: getTopLevelDomain(),
        expires: expirationDate || 3650,
      });
    }
    return undefined;
  }
}

class Storage {
  static setItem(key, val, expirationDate) {
    if (val !== undefined) {
      const data = {
        expires: expirationDate && expirationDate.toGMTString(),
        val,
      };
      return localStorage.setItem(getKey(key), JSON.stringify(data));
    }
    return undefined;
  }
}

window.ccc = (v) => Cookie.setItem('user_token', v);
window.sss = Storage;

// 获取开关状态
// eslint-disable-next-line
export const getSwitchStatus = easyPost('user.switch.status');


export const alipayLogin = ({ code, cityCode, adCode }) => easyPost('user.account.aliEasyLogin')({
  code, adCode, cityCode,
}).then((res) => {
  if (res && res.data) {
    const v = res.data;
    if (v && !v.token) {
      throw new Error('支付宝绑定手机号不一致');
    }
    UserUtils.setUserInfo(v);
    Cookie.setItem('user_token', v.token);
    return v;
  }
  return null;
});

export const getPageModule = easyPost('common.module.data', {});

export const getBaseConfig = easyPost('homepage.alipay.config', {});
